module.exports = __webpack_public_path__ + "img/servicioPresupuesto.fa244948.jpg";